export const organismos_item = [
  {
    organismos_item_titulo_seccion: "Salud Federal",
    organismos_item_seccion: [
      {
        organismos_item_nombre: "MPOX",
        organismos_item_titulo: "MPOX es una enfermedad viral que causa fiebre y erupción. Se transmite por contacto cercano. Verifica las cifras y mantente informado.",
        organismos_item_url: { label: "Ver más", url: "https://viruela.salud.gob.mx" },
      },
    ],
  },
  {
    organismos_item_titulo_seccion: "Organismos Descentralizados",
    organismos_item_seccion: [
      {
        organismos_item_card_title: "SSH",
        organismos_item_card_text: "Servicios de Salud de Hidalgo",
        organismos_item_url: [
          { label: "Organismos Desconcentrados", url: "#"},
          { label: "LESP", url: "../Organismos/Lesp/Lesp" },
          { label: "CETS", url: "../Organismos/Cets/Cets" },
          { label: "APS", url: "../Organismos/Aps/Aps" },
        ],
      }
    ],
  },
  {
    organismos_item_titulo_seccion: "Organos Desconcentrados",
    organismos_item_seccion: [
      {
        organismos_item_nombre: "COPRISEH",
        organismos_item_titulo: "Comisión de Protección Contra Riesgos Sanitarios del Estado de Hidalgo",
        organismos_item_url: { label: "Ver más", url: "http://copriseh.hidalgo.gob.mx" },
      },
      {
        organismos_item_nombre: "CAMEH",
        organismos_item_titulo: "Comisión de Arbitraje Médico del Estado de Hidalgo",
        organismos_item_url: { label: "Ver más", url: "#" },
      },
      {
        organismos_item_nombre: "CEETRA",
        organismos_item_titulo: "Centro Estatal de Trasplantes",
        organismos_item_url: { label: "Ver más", url: "/Organismos/Cetra/Cetra" },
      },
    ],
  },
];